import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import {getMaxImageSize} from '../../../../config/app';
import API from '../lib/api';
import classnames from 'classnames';
import {displayAlert} from '../actions/app';
import i18n from 'i18n';

const MAX_IMAGE_SIZE = getMaxImageSize();

const UploadImage = createClass({
  propTypes: {
    className: PropTypes.string,
    label: PropTypes.any,
    loadingLabel: PropTypes.any,
    references: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    type: PropTypes.oneOf(['ProfileImage', 'CampaignCover', 'Ad', 'ReachProfileImage', 'BankId']),
    disabled: PropTypes.bool,
    onError: PropTypes.func
  },

  getDefaultProps() {
    return {
      references: ''
    };
  },

  getInitialState() {
    return {
      loading: false
    };
  },

  onSelectImage(event) {
    const {disabled, references, type} = this.props;
    const {loading} = this.state;

    const file = event.target.files[0];
    if (file.size > MAX_IMAGE_SIZE) return this.onMaxFileSizeExceeded();

    const uploadData = {file, references, type};
    if (!file || loading || disabled) return;

    this.setState({loading: true});
    API.uploadImage(uploadData, (err, res) => {
        if (err) this.onImageUploadFail();
        if (!this.isMounted()) return;

        this.clearUploadInputVal();
        this.onUploadImage(res.data);
        this.setState({loading: false});
    });
  },

  onImageUploadFail() {
    this.clearUploadInputVal();

    displayAlert({
      type: 'error',
      title: i18n.get('DEFAULT_ERROR_TITLE'),
      message: i18n.get('UPLOAD_IMAGE_UPLOAD_ERROR_MESSAGE')
    });
  },


  onMaxFileSizeExceeded() {
    this.clearUploadInputVal();

    displayAlert({
      type: 'warning',
      title: i18n.get('UPLOAD_IMAGE_UPLOAD_WARNING_TITLE'),
      message: i18n.get('UPLOAD_IMAGE_UPLOAD_WARNING_MESSAGE')
    });
  },

  onUploadImage(image) {
    if (this.props.onChange) this.props.onChange(image);
  },

  clearUploadInputVal() {
    this.uploadInput.value = null;
  },

  handleClick() {
    if (this.props.disabled) return;
    this.uploadInput.click();
  },

  render() {
    const {
      className,
      disabled,
      loadingLabel = i18n.get('LOADING'),
      label = i18n.get('UPLOAD_IMAGE_UPLOAD_LABEL')
    } = this.props;
    const {loading} = this.state;
    const classes = classnames('vf-upload-image vf-no-selectable', className, {
      'disabled vf-hide': disabled
    });

    return (
      <div onClick={this.handleClick}>
        <label htmlFor='file'>
          <button className={classes}>
            <div>{loading ? loadingLabel : label}</div>

            <input
              ref={(ref) => this.uploadInput = ref}
              name='file'
              type='file'
              accept='image/jpeg,image/bmp,image/png'
              onChange={this.onSelectImage}
              disabled={disabled}
            />
          </button>
        </label>
      </div>
    );
  }
});

module.exports = UploadImage;
